import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

export default function DataManagementNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = location.pathname.includes('/data-management/dedup-jobs')
    ? 'dedup-jobs'
    : location.pathname.includes('/data-management/dedup-rules')
      ? 'dedup-rules'
      : location.pathname.includes('/data-management/exports')
        ? 'exports'
        : 'imports';

  const items = [
    { key: 'imports', label: t('data_management.import_jobs_title') },
    { key: 'exports', label: t('data_management.export_jobs_title') },
    { key: 'dedup-rules', label: t('data_management.dedup_rules_title') },
    { key: 'dedup-jobs', label: t('data_management.dedup_jobs_title') },
  ];

  return (
    <Tabs
      activeKey={activeKey}
      items={items}
      onChange={(key) => navigate(`/data-management/${key}`)}
      style={{ marginBottom: 16 }}
    />
  );
}
